import {
    MSG_SET_ACTIVE,
    MSG_ENSURE_DM_SUCCESS,
    MSG_CONV_LIST_REQUEST, MSG_CONV_LIST_SUCCESS, MSG_CONV_LIST_FAILURE,
    MSG_THREAD_REQUEST, MSG_THREAD_SUCCESS, MSG_THREAD_FAILURE, MSG_THREAD_PREPEND,
    MSG_SEND_REQUEST, MSG_SEND_SUCCESS, MSG_SEND_FAILURE,
    MSG_RECEIVE, MSG_MARK_READ_SUCCESS,
  } from '../actions/types';
  
  const initialState = {
    activeId: null,
    loadingConversations: false,
    conversations: [], // [{ id, is_group, created_at, last_message, unread }]
    threads: {
      // [conversationId]: {
      //   loading: false,
      //   items: [],         // array of messages (oldest → newest)
      //   nextCursor: null,  // for older pages
      // }
    },
  };
  
  export default function msgReducer(state = initialState, action) {
    switch (action.type) {
      case MSG_SET_ACTIVE:
        return { ...state, activeId: action.payload };
  
      case MSG_ENSURE_DM_SUCCESS: {
        const { id } = action.payload;
        // if not in conversations list yet, prepend a shell; list endpoint will hydrate later
        const exists = state.conversations.some(c => c.id === id);
        return exists
          ? state
          : { ...state, conversations: [{ id, is_group: false, created_at: new Date().toISOString(), last_message: null, unread: 0 }, ...state.conversations] };
      }
  
      case MSG_CONV_LIST_REQUEST:
        return { ...state, loadingConversations: true };
      case MSG_CONV_LIST_FAILURE:
        return { ...state, loadingConversations: false };
      case MSG_CONV_LIST_SUCCESS:
        return { ...state, loadingConversations: false, conversations: action.payload };
  
      case MSG_THREAD_REQUEST: {
        const { conversationId } = action.meta || {};
        const curr = state.threads[conversationId] || { loading: false, items: [], nextCursor: null };
        return {
          ...state,
          threads: {
            ...state.threads,
            [conversationId]: { ...curr, loading: true },
          },
        };
      }
  
      case MSG_THREAD_SUCCESS: {
        const { conversationId, messages, nextCursor } = action.payload;
        return {
          ...state,
          threads: {
            ...state.threads,
            [conversationId]: {
              loading: false,
              items: messages,      // newest last
              nextCursor,
            },
          },
        };
      }
  
      case MSG_THREAD_PREPEND: {
        const { conversationId, messages, nextCursor } = action.payload;
        const curr = state.threads[conversationId] || { loading: false, items: [], nextCursor: null };
        return {
          ...state,
          threads: {
            ...state.threads,
            [conversationId]: {
              loading: false,
              items: [...messages, ...curr.items],
              nextCursor,
            },
          },
        };
      }
  
      case MSG_SEND_REQUEST: {
        // optional: optimistic UI could append a temp message here
        return state;
      }
      case MSG_SEND_FAILURE:
        return state;
  
      case MSG_SEND_SUCCESS:
      case MSG_RECEIVE: {
        const { conversationId, message } = action.payload;
        const curr = state.threads[conversationId] || { loading: false, items: [], nextCursor: null };
        // append new message to this thread
        const items = [...curr.items, message];
        // also update last_message & unread in conversations
        const conversations = state.conversations.map(c =>
          c.id === conversationId
            ? {
                ...c,
                last_message: {
                  body: message.body,
                  created_at: message.created_at,
                  sender_id: message.sender_id,
                },
                // unread heuristic; real unread is computed on fetch; we 0 it if this is active & from others read later
                unread: state.activeId === conversationId ? 0 : (c.unread || 0) + (message.sender_id !== /* you can’t access user id here easily */ -1 ? 1 : 0),
              }
            : c
        );
        return {
          ...state,
          conversations,
          threads: {
            ...state.threads,
            [conversationId]: { ...curr, items },
          },
        };
      }
  
      case MSG_MARK_READ_SUCCESS: {
        const { conversationId } = action.payload;
        const conversations = state.conversations.map(c =>
          c.id === conversationId ? { ...c, unread: 0 } : c
        );
        return { ...state, conversations };
      }
  
      default:
        return state;
    }
  }